import { render, staticRenderFns } from "./PublicationAttachmentPhotos.vue?vue&type=template&id=1fa2cfb8"
import script from "./PublicationAttachmentPhotos.vue?vue&type=script&lang=js"
export * from "./PublicationAttachmentPhotos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports